import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles, type Lang } from "@/mocks/articles";

export default function GuidesSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language.split("-")[0] as Lang) || "en";
  const list = articles[lang] ?? articles.en;

  return (
    <section id="guides" className="w-full scroll-mt-24 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("guides.title")}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t("guides.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={article.heroImage}
                  alt={article.title}
                  title={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line"></i>
                  </span>
                  {article.readTime}
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                  {article.shortAnswer}
                </p>
                <span className="mt-auto pt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-700">
                  {t("guides.readMore")}
                  <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}